import { useLingui } from '@lingui/react/macro';

import { DesktopEntityFilter } from '@/components/SharedFilters/EntityFilter/DesktopEntityFilter';
import IconPlace from '@/icons/Place.svg';

import { useFilters } from '../FiltersState';

export const FiltersOrigin = ({ tag }: { tag?: boolean }) => {
  const { t } = useLingui();

  const {
    origins: { origins, setOrigins },
  } = useFilters();

  const selectedOriginsCount = origins.length;

  return (
    <DesktopEntityFilter
      selectedEntities={origins}
      setSelectedEntities={setOrigins}
      traits={['store', 'workshop']}
      tag={tag}
      label={t({ id: 'shipments.filters.origin.label', message: 'Origin' })}
      searchPlaceholder={t({
        id: 'shipments.filters.origin.search.label',
        message: 'Search origins',
      })}
      icon={<IconPlace start />}
      tagSelectedCountLabel={t({
        id: 'shipments.filters.origin.multiple',
        message: `${selectedOriginsCount} origins`,
      })}
    />
  );
};
